module.exports = __webpack_public_path__ + "static/img/2929_phase_function_Paper_Points.c2c050f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2929_phase_function_Paper_Points.png
// module id = uo/e
// module chunks = 0